import React, { Component } from 'react';
import { Page, Layout, Card, FormLayout, TextField, RangeSlider, Banner, Checkbox, RadioButton, ButtonGroup, Button, LegacyStack, Select, PageActions, SettingToggle, Text, Tooltip, TextContainer, Icon } from '@shopify/polaris';
import { InfoMinor } from '@shopify/polaris-icons';
import { SkeletonPageCustom } from './SkeletonPageCustom';
import { ColorPickerCustom } from './ColorPickerCustom';
import { DesktopMajor, MobileMajor } from '@shopify/polaris-icons';
import { fetchApi } from './helpers/fetchApi';

var btnAnimation = "";
let countDownTimerintervalId
export class StickyAddToCartBar extends Component {

    constructor(props) {
        super(props);
        props.setIsLoading(true);

        this.saveChanges = this.saveChanges.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.togglePreviewActive = this.togglePreviewActive.bind(this);
        this.setCountDownTimer = this.setCountDownTimer.bind(this);
        let prevActive = true;

        if(window.innerWidth < 768) {
            prevActive = false;
        }
        this.state = { initState: {}, model: {}, loading: true, previewActive: prevActive, previewDesktop: true };
    }

    updateCountDownTimerVal(elem, value, checkVal, abbrElem) {


        if (checkVal === "" && value == "00") {
            elem.textContent = "";
            window.$(abbrElem).hide();
        } else {
            elem.textContent = value === "00" ? "0" : value;
            window.$(abbrElem).show();
        }
    }
    componentDidMount() {
        this.populateData();
        this.props.setSaveChanges(this.saveChanges);

    }

    

    handleChange(fieldName, newValue) {

        this.setState(prevState => {
            let model = Object.assign({}, prevState.model);
            model[fieldName] = newValue;
            this.props.setIsDirty(JSON.stringify(this.state.initState) !== JSON.stringify(model));
            return { model };
        });

        if (fieldName === 'buttonAnimation') {
            btnAnimation = newValue;
            window.$('.satcb_btn').satcb_animateCss(btnAnimation);
        }

        clearInterval(countDownTimerintervalId)
        this.setCountDownTimer();

    }

    setCountDownTimer() {
    clearInterval(countDownTimerintervalId);

    window.$(".sticky_cart__timer_item").show();

    const oneDay = 86400000;
    const oneHour = 3600000;
    const oneMinute = 60000;
    const oneSecond = 1000;

    countDownTimerintervalId = setInterval(() => {
        let timerElem = document.getElementById("count_down_timer");
        if (!timerElem) return;

        let preview = this.state.previewDesktop ? "desktop" : "mobile";
        let wrapElem = document.querySelector(".sticky_cart_timer_wrap");

        if (preview === "mobile") {
            wrapElem.style.flexDirection = "column";
            wrapElem.style.padding = "0px";
            wrapElem.style.gap = "10px";
            timerElem.style.width = "413px";
            timerElem.style.margin = "auto";
        } else {
            wrapElem.style.flexDirection = "";
            wrapElem.style.padding = "3px";
            wrapElem.style.gap = "15px";
        }

        let model = this.state.model;

        // ELEMENTS
        let daysElem = document.querySelector(".sticky_cart__days");
        let hoursElem = document.querySelector(".sticky_cart__hours");
        let minutesElem = document.querySelector(".sticky_cart_minutes");
        let secondsElem = document.querySelector(".sticky_cart_seconds");

        if (!daysElem) return;

        let endTime;

        // ============================================
        // FIXED END DATE MODE
        // ============================================
        if (model.countDownTimerType === "fixed") {

            if (!model.countDownTimerEndDate) {
                // No date specified — show nothing
                clearInterval(countDownTimerintervalId);
                window.$(".sticky_cart__timer_item").hide();
                return;
            }
            endTime = new Date(this.state.model.countDownTimerEndDate).getTime();

            //endTime = new Date(model.countDownTimerEndDate).getTime();
        }

        // ============================================
        // REPEAT MODE
        // ============================================
        else {
            let d = parseInt(model.countDownTimerDays || 0);
            let h = parseInt(model.countDownTimerHours || 0);
            let m = parseInt(model.countDownTimerMinutes || 0);
            let s = parseInt(model.countDownTimerSeconds || 0);

            let total = d * oneDay + h * oneHour + m * oneMinute + s * oneSecond;

            endTime = Date.now() + total;

            //let dayMS = parseInt(this.state.model.countDownTimerDays || 0) * oneDayAsMilliSecond;
            //let hourMS = parseInt(this.state.model.countDownTimerHours || 0) * oneHourAsMilliSecond;
            //let minMS = parseInt(this.state.model.countDownTimerMinutes || 0) * oneMinuteAsMilliSecond;
            //let secMS = parseInt(this.state.model.countDownTimerSeconds || 0) * oneSecondAsMilliSecond;

            //endTime = Date.now() + (dayMS + hourMS + minMS + secMS);
        }

        // ============================================
        // CALCULATE REMAINING TIME
        // ============================================
        let distance = endTime - Date.now();

        if (distance <= 0) {
            clearInterval(countDownTimerintervalId);

            // hide blocks only in fixed mode
            if (model.countDownTimerType === "fixed") {
                window.$(".sticky_cart__timer_item").hide();
            }

            document.querySelector(".count_down_timer_end").textContent = "";
            return;
        }

        let days = Math.floor(distance / oneDay);
        let hours = Math.floor((distance % oneDay) / oneHour);
        let minutes = Math.floor((distance % oneHour) / oneMinute);
        let seconds = Math.floor((distance % oneMinute) / oneSecond);

        // Format to 2 digits
        days = days < 10 ? "0" + days : String(days);
        hours = hours < 10 ? "0" + hours : String(hours);
        minutes = minutes < 10 ? "0" + minutes : String(minutes);
        seconds = seconds < 10 ? "0" + seconds : String(seconds);

        // Update UI
        daysElem.textContent = days;
        hoursElem.textContent = hours;
        minutesElem.textContent = minutes;
        secondsElem.textContent = seconds;

    }, 1000);
}


    handlePreview(previewDesktop) {
        this.setState({ previewDesktop: previewDesktop });
        var topNavTimer = setInterval(function(){
            if(window.$('#preview').length > 0){
                setTimeout(function () { window.$('#preview').sticky('update'); }, 0);
            }
        },500);
    }

    togglePreviewActive() {
        this.setState({ previewActive: !this.state.previewActive });

        var topNavTimer = setInterval(function(){
            if(window.$('#preview').length > 0){
                setTimeout(function () { window.$('#preview').sticky('update'); }, 0);
            }
        },500);
    }



    render() {
        let pageTitleText = this.props.isOnboardingStep == false ? 'Sticky Add To Cart Bar' : 'Choose prefences for your Sticky Add To Cart Bar';

        return (
            this.state.loading ?
                <SkeletonPageCustom />
                :
                <Page title={pageTitleText}>
                    <Layout>
                        <Layout.Section>
                            {this.props.common.hasFreePlanActivated && this.props.common.freePlanClicksUsed <= 0 && (
                                <Banner
                                    title={`Free Plan Usage Limit Reached: App Paused Until ${(new Date(this.props.common.freePlanCreditsResetDate)).toLocaleString(undefined, {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })}`}
                                    status="critical"
                                    action={{
                                        content: 'Upgrade now', onAction: () => {
                                            const params = new URLSearchParams(this.state.url);
                                            const shop = params.get("shop");
                                            const host = params.get("host");
                                            window.open('/plans?shop=' + shop + '&host=' + host, '_self');
                                        }
                                    }}
                                >
                                    <p>
                                        Your store is currently on the Free plan whose limit is reached and the STKTY app is paused until your next 30-day cycle. Upgrade your plan now to avoid disruptions.
                                    </p>
                                </Banner>
                            )}
                            {this.props.common.hasFreePlanActivated && this.props.common.freePlanClicksUsed > 0 && (
                                <Banner
                                    title={`Free Plan Usage: ${this.props.common.freePlanClicksUsed >= 0 ? this.props.common.freePlanClicksUsed : 0} clicks left out of 25`}
                                    status="warning"
                                    action={{
                                        content: 'View plans', onAction: () => {
                                            const params = new URLSearchParams(this.state.url);
                                            const shop = params.get("shop");
                                            const host = params.get("host");
                                            window.open('/plans?shop=' + shop + '&host=' + host, '_self');
                                        }
                                    }}
                                >
                                    <p>
                                        Your store is currently on the Free plan. Once 25 clicks are reached, all STKY widgets will be paused until your next 30-day cycle. Upgrade your plan today to avoid disruptions.
                                    </p>
                                </Banner>
                            )}
                        </Layout.Section>
                        <Layout.Section>
                            <Banner
                                title="What is Sticky Add To Cart Bar/Button?"
                                status="info"
                            >
                                <p>Sticky Add To Cart Bar is the top bar that becomes visible when the customer scrolls beyond your Buy button. The bar contains the Buy button so user can quickly add your product to the cart without scrolling back up. You can also enable the Skip to Checkout feature and send customers directly to checkout.</p>
                            </Banner>
                        </Layout.Section>
                        <Layout.Section>
                            <div id="preview" className={(this.state.previewDesktop ? 'desktop' : 'mobile') + (this.state.previewActive ? '' : ' preview-hidden')}>

                                <Card title="Preview" sectioned actions={[{ content: this.state.previewActive ? 'Collapse ↑' : 'Expand ↓', onAction: this.togglePreviewActive }]}>
                                    {this.state.model.enable_CountDownTimer && this.props.isOnboardingStep == false &&
                                        <div id="count_down_timer" style={{ backgroundColor: this.state.model.countDownTimerBgColor, width: this.state.previewDesktop ? '100%' : '414px', }}>
                                            <div className="sticky_cart_timer_wrap">
                                                <div className="sticky_cart_timer_title" style={{ color: this.state.model.countDownTimertxtColor, fontSize: this.state.model.countDownTimerTxtFontSize + "px" }}>{this.state.model.countDownTimerText}</div>
                                                <div className="sticky_cart_timer">
                                                    <div className="sticky_cart__timer_item sticky_cart_item_days">
                                                        <span className="sticky_cart__days sticky_cart__timer--number" style={{ color: this.state.model.countDownTimerDurationColor, fontSize: this.state.model.countDownTimerDurationFontSize + "px" }}>{this.state.model.countDownTimerDays}</span>
                                                        <span className="sticky_cart_timer_text sticky_cart__timer--days" style={{ color: this.state.model.countDownTimerDurationColor, fontSize: this.state.model.countDownTimerDurationFontSize + "px" }}>{this.state.model.countDownTimerDayAbbr}</span>
                                                    </div>
                                                    <span className="sticky_cart_timer--span timer--span_first hide">:</span>
                                                    <div className="sticky_cart__timer_item sticky_cart__timer__item--hours">
                                                        <span className="sticky_cart__hours sticky_cart__timer--number" style={{ color: this.state.model.countDownTimerDurationColor, fontSize: this.state.model.countDownTimerDurationFontSize + "px" }}>{this.state.model.countDownTimerHours}</span>
                                                        <span className="sticky_cart_timer_text sticky_cart__timer--hours" style={{ color: this.state.model.countDownTimerDurationColor, fontSize: this.state.model.countDownTimerDurationFontSize + "px" }}>{this.state.model.countDownTimerHourAbbr}</span>
                                                    </div>
                                                    <span className="sticky_cart_timer--span timer--span_second hide">:</span>
                                                    <div className="sticky_cart__timer_item sticky_cart_timer_item_minutes">
                                                        <span className="sticky_cart_minutes sticky_cart_timer_number" style={{ color: this.state.model.countDownTimerDurationColor, fontSize: this.state.model.countDownTimerDurationFontSize + "px" }}>{this.state.model.countDownTimerMinutes}</span>
                                                        <span className="sticky_cart_timer_text sticky_cart_timer_minutes" style={{ color: this.state.model.countDownTimerDurationColor, fontSize: this.state.model.countDownTimerDurationFontSize + "px" }}>{this.state.model.countDownTimerMinAbbr}</span>
                                                    </div >
                                                    <span className="sticky_cart_timer_span timer_span_third hide">:</span>
                                                    <div className="sticky_cart__timer_item sticky_cart_timer_item_seconds">
                                                        <span className="sticky_cart_seconds sticky_cart_timer_number" style={{ color: this.state.model.countDownTimerDurationColor, fontSize: this.state.model.countDownTimerDurationFontSize + "px" }}>{this.state.model.countDownTimerSeconds}</span>
                                                        <span className="sticky_cart_timer_text sticky_cart_timer_seconds" style={{ color: this.state.model.countDownTimerDurationColor, fontSize: this.state.model.countDownTimerDurationFontSize + "px" }}>{this.state.model.countDownTimerSecAbbr}</span >
                                                    </div >
                                                    <div className="count_down_timer_end"></div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <Card.Section>
                                        <div className="satcb_bar designNo0 designNo3 desktop_bar" style={{
                                            opacity: (this.state.model.opacity / 100),
                                            width: this.state.previewDesktop ? '100%' : '414px',
                                            fontFamily: this.state.model.satcbBarFont ? this.state.model.satcbBarFont : '',
                                            backgroundColor: this.state.model.barBackgroundColor ? this.state.model.barBackgroundColor : '#fff',
                                            display: (!this.state.previewDesktop && this.state.model.useFullWidthButtonMobile) || !this.state.previewActive ? 'none' : 'block'
                                        }}>
                                            <div className="satcb_thumb-img">
                                                <img className="satcb_thumb" alt="Awesome Sneakers" src="https://cdn.shopify.com/s/files/1/1832/6893/products/ni313171_600_thum1_10_674_17041.jpg?v=1489009994"
                                                    style={{ display: (this.state.previewDesktop && this.state.model.showProductImageDesktop) || (!this.state.previewDesktop && this.state.model.showProductImageMobile) ? 'block' : 'none' }} />
                                            </div>
                                            <div className="satcb_title" >
                                                <a className="satcb_title_a" href="/#" onClick={(e) => e.preventDefault()}
                                                    style={{
                                                        color: this.state.model.productTitleColor ? this.state.model.productTitleColor : '#3d4246',
                                                        fontSize: this.state.model.proTitleFontSize ? this.state.model.proTitleFontSize + "px" : '16px',
                                                        display: (this.state.previewDesktop && this.state.model.showProductTitleDesktop) || (!this.state.previewDesktop && this.state.model.showProductTitleMobile) ? 'inline-block' : 'none'
                                                    }}>
                                                    Awesome Sneakers<span className="satcb_variant_title"> - Red / 11</span>
                                                </a>
                                                <div className="satcb_reviews_stars" style={{ display: (this.state.previewDesktop && this.state.model.showReviewStarsDesktop) || (!this.state.previewDesktop && this.state.model.showReviewStarsMobile) ? 'block' : 'none' }}>
                                                    <meta itemProp="bestRating" content="5" />
                                                    <meta itemProp="worstRating" content="1" />
                                                    <meta itemProp="reviewCount" content="1" />
                                                    <meta itemProp="ratingValue" content="5.0" />
                                                    <i className="spr-icon spr-icon-star"></i><i className="spr-icon spr-icon-star"></i><i className="spr-icon spr-icon-star"></i><i className="spr-icon spr-icon-star"></i><i className="spr-icon spr-icon-star"></i>
                                                    <a href="/#" onClick={(e) => e.preventDefault()} className="satcb_reviews_count">(1)</a>
                                                </div>
                                            </div>
                                            {window.innerWidth < 768 ? <br/> : ''}
                                            <div className="satcb_btn">
                                                <button style={{
                                                    color: this.state.model.buttonTextColor ? this.state.model.buttonTextColor : '#fff',
                                                    fontSize: this.state.model.proButtonFontSize ? this.state.model.proButtonFontSize + "px" : '16px',
                                                    backgroundColor: this.state.model.buttonColor ? this.state.model.buttonColor : '#7796a8',
                                                    borderColor: this.state.model.buttonColor ? this.state.model.buttonColor : '#7796a8',
                                                }}
                                                    type="submit" name="add" className="primary product-form__cart-submit">{this.state.model.buttonText ? this.state.model.buttonText : 'ADD TO CART'}
                                                </button>
                                            </div>
                                            <div className="satcb_confirmation">
                                                Product Added!
                                            </div>
                                            <div className="satcb_price" style={{
                                                color: this.state.model.priceColor ? this.state.model.priceColor : '#212b36',
                                                fontSize: this.state.model.proPriceFontSize ? this.state.model.proPriceFontSize + "px" : '16px',
                                                display: (this.state.previewDesktop && this.state.model.showPriceDesktop) || (!this.state.previewDesktop && this.state.model.showPriceMobile) ? 'flex' : 'none'
                                            }}>
                                                $129.00
                                            </div>
                                            <div className="satcb_was_price" style={{
                                                color: this.state.model.comparePriceColor ? this.state.model.comparePriceColor : '#999',
                                                display: (this.state.previewDesktop && this.state.model.showComparePriceDesktop) || (!this.state.previewDesktop && this.state.model.showComparePriceMobile) ? 'flex' : 'none'
                                            }}>
                                                $159.00
                                            </div>
                                            <div className="satcb_variants">
                                                <select className="single-option-selector single-option-selector-product-template product-form__input" id="SingleOptionSelector-0" data-index="option1" defaultValue="Red"
                                                    style={{ display: (this.state.previewDesktop && this.state.model.variantsEnabledDesktop) || (!this.state.previewDesktop && this.state.model.variantsEnabledMobile) ? 'inline-block' : 'none' }}>
                                                    <option value="Red">Red</option>
                                                </select>
                                                <select className="single-option-selector single-option-selector-product-template product-form__input" id="SingleOptionSelector-1" data-index="option2" defaultValue="11"
                                                    style={{ display: (this.state.previewDesktop && this.state.model.variantsEnabledDesktop) || (!this.state.previewDesktop && this.state.model.variantsEnabledMobile) ? 'inline-block' : 'none' }}>
                                                    <option value="10">10</option>
                                                    <option value="11">11</option>
                                                </select>
                                                <div className="satcb_qty" style={{ display: (this.state.previewDesktop && this.state.model.qtyEnabledDesktop) || (!this.state.previewDesktop && this.state.model.qtyEnabledMobile) ? 'flex' : 'none' }}>
                                                    <input type="number" name="quantity" defaultValue="1" min="1" pattern="[0-9]*" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="satcb_bar designNo2" style={{ opacity: (this.state.model.opacity / 100), display: !this.state.previewDesktop && this.state.model.useFullWidthButtonMobile && this.state.previewActive ? 'block' : 'none' }}>
                                            <div className="satcb_variants" style={{
                                                float: !this.state.model.variantsEnabledMobile && this.state.model.qtyEnabledMobile ? 'left' : 'none',
                                                width: !this.state.model.variantsEnabledMobile && this.state.model.qtyEnabledMobile ? '10%' : '100%',
                                            }}>
                                                <select className="single-option-selector single-option-selector-product-template product-form__input" id="SingleOptionSelector-0" data-index="option1" defaultValue="Red"
                                                    style={{
                                                        display: this.state.model.variantsEnabledMobile ? 'inline-block' : 'none',
                                                        width: this.state.model.qtyEnabledMobile ? '45%' : '50%'
                                                    }}>
                                                    <option value="Red">Red</option>
                                                </select>
                                                <select className="single-option-selector single-option-selector-product-template product-form__input" id="SingleOptionSelector-1" data-index="option2" defaultValue="11"
                                                    style={{
                                                        display: this.state.model.variantsEnabledMobile ? 'inline-block' : 'none',
                                                        width: this.state.model.qtyEnabledMobile ? '45%' : '50%'
                                                    }}>
                                                    <option value="10">10</option>
                                                    <option value="11">11</option>
                                                </select>
                                                <input type="number" name="quantity" defaultValue="1" min="1" pattern="[0-9]*" style={{
                                                    display: this.state.model.qtyEnabledMobile ? 'inline-block' : 'none',
                                                    width: !this.state.model.variantsEnabledMobile && this.state.model.qtyEnabledMobile ? '100%' : '10%',
                                                    height: !this.state.model.variantsEnabledMobile && this.state.model.qtyEnabledMobile ? '42px' : 'auto',
                                                }} />
                                            </div>
                                            <div className="satcb_btn" style={{
                                                float: !this.state.model.variantsEnabledMobile && this.state.model.qtyEnabledMobile ? 'right' : 'none',
                                                width: !this.state.model.variantsEnabledMobile && this.state.model.qtyEnabledMobile ? '90%' : 'auto',
                                            }}>
                                                <button style={{
                                                    color: this.state.model.buttonTextColor ? this.state.model.buttonTextColor : '#fff',
                                                    backgroundColor: this.state.model.buttonColor ? this.state.model.buttonColor : '#7796a8',
                                                    borderColor: this.state.model.buttonColor ? this.state.model.buttonColor : '#7796a8',
                                                }}
                                                    type="submit" name="add" className="primary product-form__cart-submit">{this.state.model.buttonText ? this.state.model.buttonText : 'ADD TO CART'}
                                                </button>
                                            </div>
                                        </div>
                                    </Card.Section>
                                    <LegacyStack alignment="center" distribution="center">
                                        <div style={{ display: this.state.previewActive ? 'block' : 'none' }}>
                                            <ButtonGroup segmented con>
                                                <Button pressed={this.state.previewDesktop} onClick={(newValue) => this.handlePreview(true)} icon={DesktopMajor}>Desktop Preview</Button>
                                                <Button pressed={!this.state.previewDesktop} onClick={(newValue) => this.handlePreview(false)} icon={MobileMajor}>Mobile Preview</Button>
                                            </ButtonGroup>
                                        </div>
                                    </LegacyStack>
                                </Card>
                            </div>
                        </Layout.Section>
                        <Layout.AnnotatedSection
                            title="Sticky Add To Cart Bar State"
                        >
                            <SettingToggle action={{
                                content: this.state.model.enabled ? 'Disable' : 'Enable',
                                onAction: () => { this.handleChange('enabled', !this.state.model.enabled) }
                            }}
                                enabled={this.state.model.enabled}
                            >
                                Sticky Add To Cart Bar is currently <Text as="span" fontWeight="semibold">{this.state.model.enabled ? 'enabled' : 'disabled'}</Text>.
                            </SettingToggle>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection
                            title="General Settings"
                            description=""
                        >
                            <Card sectioned>
                                <FormLayout>
                                    <Checkbox
                                        label="Skip to Checkout when clicked on Sticky Add to Cart Button"
                                        checked={this.state.model.skipCart}
                                        onChange={(newValue) => this.handleChange('skipCart', newValue)}
                                    />
                                    <Select
                                        label="Button Animation"
                                        helpText="Repeats every 5 seconds"
                                        options={[{ label: 'None', value: 'none' }, { label: 'Bounce', value: 'bounce' }, { label: 'Flash', value: 'flash' }, { label: 'Pulse', value: 'pulse' }, { label: 'Rubber band', value: 'rubberBand' }, { label: 'Shake', value: 'shake' }, { label: 'Swing', value: 'swing' }, { label: 'Tada', value: 'tada' }, { label: 'Wobble', value: 'wobble' }, { label: 'Jello', value: 'jello' }]}
                                        onChange={(newValue) => this.handleChange('buttonAnimation', newValue)}
                                        value={this.state.model.buttonAnimation}
                                    />
                                    <LegacyStack vertical spacing="tight">
                                        <LegacyStack wrap={false} alignment="center" spacing="tight">
                                            <Checkbox
                                                label="Enable Tracking"
                                                checked={this.state.model.trackingEnabled}
                                                onChange={(newValue) => this.handleChange('trackingEnabled', newValue)}

                                            />
                                            <Tooltip content="This attribute can be used for app auditing and will appear in your Shopify order details page. The attribute name is _Added with Sticky Add To Cart BOOSTER PRO's Sticky Add To Cart Bar. This is not visible to your customers.">
                                                <div style={{ lineHeight: 'normal', marginLeft: '4px' }}>
                                                    <Icon source={InfoMinor} color="inkLightest" />
                                                </div>
                                            </Tooltip>
                                        </LegacyStack>
                                    </LegacyStack>
                                </FormLayout>
                            </Card>
                        </Layout.AnnotatedSection>


                            <Layout.AnnotatedSection
                                title="Look and Feel"
                                description="App will automatically match your site's branding but you can also adjust it's look and feel to your liking here."
                            >
                                <Card sectioned>
                                    <FormLayout>
                                        <RangeSlider
                                            output
                                            label="Opacity"
                                            min={0}
                                            step={5}
                                            max={100}
                                            onChange={(newValue) => this.handleChange('opacity', JSON.stringify(newValue))}
                                            value={this.state.model.opacity}
                                        />
                                        <TextField
                                            value={this.state.model.buttonText}
                                            onChange={(newValue) => this.handleChange('buttonText', newValue)}
                                            label="Override Button Text"
                                        />
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Override Button Color"
                                                fieldName="buttonColor"
                                                value={this.state.model.buttonColor}
                                                handleChange={this.handleChange}
                                            />
                                            <ColorPickerCustom
                                                label="Override Button Text Color"
                                                fieldName="buttonTextColor"
                                                value={this.state.model.buttonTextColor}
                                                handleChange={this.handleChange}
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Override Bar Background Color"
                                                fieldName="barBackgroundColor"
                                                value={this.state.model.barBackgroundColor}
                                                handleChange={this.handleChange}
                                            />
                                            <ColorPickerCustom
                                                label="Override Product Title Color"
                                                fieldName="productTitleColor"
                                                value={this.state.model.productTitleColor}
                                                handleChange={this.handleChange}
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Override Price Color"
                                                fieldName="priceColor"
                                                value={this.state.model.priceColor}
                                                handleChange={this.handleChange}
                                            />
                                            <ColorPickerCustom
                                                label="Override Compare Price Color"
                                                fieldName="comparePriceColor"
                                                value={this.state.model.comparePriceColor}
                                                handleChange={this.handleChange}
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group sectioned>
                                            <Select
                                                label="Override Font Face"
                                                options={[{ label: 'Default', value: "" }, { label: 'Roboto', value: 'Roboto' }, { label: 'Playfair Display', value: 'Playfair Display' }, { label: 'Open Sans', value: 'Open Sans' }, { label: 'Oswald', value: 'Oswald' }, { label: 'Cabin', value: 'Cabin' }, { label: 'Montserrat', value: 'Montserrat' }, { label: 'Merriweather', value: 'Merriweather' }, { label: 'Cormorant', value: 'Cormorant' }, { label: 'Poppins', value: 'Poppins' }, { label: 'Nunito', value: 'Nunito' }, { label: 'Lato', value: 'Lato' }]}
                                                onChange={(newValue) => this.handleChange('satcbBarFont', newValue)}
                                                value={this.state.model.satcbBarFont}
                                            />
                                            <div></div>
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <RangeSlider
                                                output
                                                label="Override Title Font Size"
                                                min={12}
                                                step={2}
                                                max={36}
                                                onChange={(newValue) => this.handleChange('proTitleFontSize', JSON.stringify(newValue))}
                                                value={this.state.model.proTitleFontSize}
                                            />
                                            <RangeSlider
                                                output
                                                label="Override Price Font Size"
                                                min={12}
                                                step={2}
                                                max={36}
                                                onChange={(newValue) => this.handleChange('proPriceFontSize', JSON.stringify(newValue))}
                                                value={this.state.model.proPriceFontSize}
                                            />
                                            <RangeSlider
                                                output
                                                label="Override Button Font Size"
                                                min={12}
                                                step={2}
                                                max={36}
                                                onChange={(newValue) => this.handleChange('proButtonFontSize', JSON.stringify(newValue))}
                                                value={this.state.model.proButtonFontSize}
                                            />
                                            <div></div>
                                        </FormLayout.Group>
                                    </FormLayout>
                                </Card>
                            </Layout.AnnotatedSection>

                            <Layout.AnnotatedSection
                                title="Desktop Settings"
                                description=""
                            >
                                <Card sectioned>
                                    <Card.Section>
                                        <FormLayout>
                                            <Checkbox
                                                label="Show on desktop computers"
                                                checked={this.state.model.showOnDesktop}
                                                onChange={(newValue) => this.handleChange('showOnDesktop', newValue)}
                                            />
                                            <Checkbox
                                                label="Show when user starts scrolling instead of when user scrolls below main Add To Cart button"
                                                checked={this.state.model.showOnLoadDesktop}
                                                onChange={(newValue) => this.handleChange('showOnLoadDesktop', newValue)}
                                            />
                                            <Checkbox
                                                label="Hide original Add To Cart button"
                                                checked={this.state.model.hideOriginalButtonDesktop}
                                                onChange={(newValue) => this.handleChange('hideOriginalButtonDesktop', newValue)}
                                            />
                                        </FormLayout>
                                    </Card.Section>
                                    <Card.Section>
                                        <FormLayout>
                                            <Checkbox
                                                label="Show Product Image"
                                                checked={this.state.model.showProductImageDesktop}
                                                onChange={(newValue) => this.handleChange('showProductImageDesktop', newValue)}
                                            />
                                            <Checkbox
                                                label="Show Product Title"
                                                checked={this.state.model.showProductTitleDesktop}
                                                onChange={(newValue) => this.handleChange('showProductTitleDesktop', newValue)}
                                            />
                                            <Checkbox
                                                label="Show Review Stars"
                                                checked={this.state.model.showReviewStarsDesktop}
                                                onChange={(newValue) => this.handleChange('showReviewStarsDesktop', newValue)}
                                            />
                                            <Checkbox
                                                label="Show Variant select"
                                                checked={this.state.model.variantsEnabledDesktop}
                                                onChange={(newValue) => this.handleChange('variantsEnabledDesktop', newValue)}
                                            />
                                            <Checkbox
                                                label="Show Quantity select"
                                                checked={this.state.model.qtyEnabledDesktop}
                                                onChange={(newValue) => this.handleChange('qtyEnabledDesktop', newValue)}
                                            />
                                            <Checkbox
                                                label="Show Quantity - and + buttons"
                                                checked={this.state.model.qtyAddRemoveEnabledDesktop}
                                                onChange={(newValue) => this.handleChange('qtyAddRemoveEnabledDesktop', newValue)}
                                            />
                                            <Checkbox
                                                label="Show Price"
                                                checked={this.state.model.showPriceDesktop}
                                                onChange={(newValue) => this.handleChange('showPriceDesktop', newValue)}
                                            />
                                            <Checkbox
                                                label="Show Compare Price"
                                                checked={this.state.model.showComparePriceDesktop}
                                                onChange={(newValue) => this.handleChange('showComparePriceDesktop', newValue)}
                                            />
                                        </FormLayout>
                                    </Card.Section>
                                    <Card.Section>
                                        <FormLayout>
                                            <p>Bar position</p>
                                            <ButtonGroup segmented con>
                                                <Button pressed={this.state.model.barPositionDesktop === 'top'} onClick={(newValue) => this.handleChange('barPositionDesktop', 'top')}>
                                                    Top
                                                </Button>
                                                <Button pressed={this.state.model.barPositionDesktop === 'bottom'} onClick={(newValue) => this.handleChange('barPositionDesktop', 'bottom')}>
                                                    Bottom
                                                </Button>
                                            </ButtonGroup>
                                            <TextField
                                                label="Position Offset"
                                                suffix="px"
                                                type="number"
                                                value={this.state.model.customPositionDesktop}
                                                onChange={(newValue) => this.handleChange('customPositionDesktop', newValue)}
                                                clearButton
                                                onClearButtonClick={() => this.handleChange('customPositionDesktop', null)}
                                                helpText="Use this to move Sticky Add To Cart Bar up or down. Depending on Bar position (top or bottom) this will push it for selected amount of pixels in corresponding direction."
                                            />
                                            <TextField
                                                label="Stack Order"
                                                type="number"
                                                value={this.state.model.zIndexDesktop}
                                                onChange={(newValue) => this.handleChange('zIndexDesktop', newValue)}
                                                clearButton
                                                onClearButtonClick={() => this.handleChange('zIndexDesktop', null)}
                                                helpText="Use this to push Sticky Add To Cart Bar either in front or behind other elements. An element with greater stack order will be in front of an element with a lower stack order."
                                            />
                                        </FormLayout>
                                    </Card.Section>
                                </Card>
                            </Layout.AnnotatedSection>
                        
                            <Layout.AnnotatedSection
                            title="Mobile Settings"
                            description=""
                        >
                            <Card sectioned>
                                <Card.Section>
                                    <FormLayout>
                                        <Checkbox
                                            label="Show on tablets and mobile devices"
                                            checked={this.state.model.showOnMobile}
                                            onChange={(newValue) => this.handleChange('showOnMobile', newValue)}
                                        />
                                        <Checkbox
                                            label="Show when user starts scrolling instead of when user scrolls below main Add To Cart button"
                                            checked={this.state.model.showOnLoadMobile}
                                            onChange={(newValue) => this.handleChange('showOnLoadMobile', newValue)}
                                        />
                                        <Checkbox
                                            label="Hide original Add To Cart button"
                                            checked={this.state.model.hideOriginalButtonMobile}
                                            onChange={(newValue) => this.handleChange('hideOriginalButtonMobile', newValue)}
                                        />
                                        <Checkbox
                                            label="Show full width Add To Cart button instead of bar"
                                            checked={this.state.model.useFullWidthButtonMobile}
                                            onChange={(newValue) => this.handleChange('useFullWidthButtonMobile', newValue)}
                                        />
                                    </FormLayout>
                                </Card.Section>
                                <Card.Section>
                                    <FormLayout>
                                        {
                                            this.state.model.useFullWidthButtonMobile ? '' :
                                                <Checkbox
                                                    label="Show Product Image"
                                                    checked={this.state.model.showProductImageMobile}
                                                    onChange={(newValue) => this.handleChange('showProductImageMobile', newValue)}
                                                />
                                        }
                                        {
                                            this.state.model.useFullWidthButtonMobile ? '' :
                                                <Checkbox
                                                    label="Show Product Title"
                                                    checked={this.state.model.showProductTitleMobile}
                                                    onChange={(newValue) => this.handleChange('showProductTitleMobile', newValue)}
                                                />
                                        }
                                        {
                                            this.state.model.useFullWidthButtonMobile ? '' :
                                                <Checkbox
                                                    label="Show Review Stars"
                                                    checked={this.state.model.showReviewStarsMobile}
                                                    onChange={(newValue) => this.handleChange('showReviewStarsMobile', newValue)}
                                                />
                                        }
                                        <Checkbox
                                            label="Show Variant select"
                                            checked={this.state.model.variantsEnabledMobile}
                                            onChange={(newValue) => this.handleChange('variantsEnabledMobile', newValue)}
                                        />
                                        <Checkbox
                                            label="Show Quantity select"
                                            checked={this.state.model.qtyEnabledMobile}
                                            onChange={(newValue) => this.handleChange('qtyEnabledMobile', newValue)}
                                        />
                                        <Checkbox
                                            label="Show Quantity - and + buttons"
                                            checked={this.state.model.qtyAddRemoveEnabledMobile}
                                            onChange={(newValue) => this.handleChange('qtyAddRemoveEnabledMobile', newValue)}
                                        />
                                        {
                                            this.state.model.useFullWidthButtonMobile ? '' :
                                                <Checkbox
                                                    label="Show Price"
                                                    checked={this.state.model.showPriceMobile}
                                                    onChange={(newValue) => this.handleChange('showPriceMobile', newValue)}
                                                />
                                        }
                                        {
                                            this.state.model.useFullWidthButtonMobile ? '' :
                                                <Checkbox
                                                    label="Show Compare Price"
                                                    checked={this.state.model.showComparePriceMobile}
                                                    onChange={(newValue) => this.handleChange('showComparePriceMobile', newValue)}
                                                />
                                        }
                                    </FormLayout>
                                </Card.Section>
                                <Card.Section>
                                    <FormLayout>
                                        <p>Bar position</p>
                                        <ButtonGroup segmented con>
                                            <Button pressed={this.state.model.barPositionMobile === 'top'} onClick={(newValue) => this.handleChange('barPositionMobile', 'top')}>
                                                Top
                                            </Button>
                                            <Button pressed={this.state.model.barPositionMobile === 'bottom'} onClick={(newValue) => this.handleChange('barPositionMobile', 'bottom')}>
                                                Bottom
                                            </Button>
                                        </ButtonGroup>
                                        <TextField
                                            label="Position Offset"
                                            suffix="px"
                                            type="number"
                                            value={this.state.model.customPositionMobile}
                                            onChange={(newValue) => this.handleChange('customPositionMobile', newValue)}
                                            clearButton
                                            onClearButtonClick={() => this.handleChange('customPositionMobile', null)}
                                            connectedRight={
                                                <Tooltip content="Use this to move Sticky Add To Cart Bar up or down. Depending on Bar position (top or bottom) this will push it for selected amount of pixels in corresponding direction.">
                                                    <Icon source={InfoMinor} color="base" />
                                                </Tooltip>
                                            }
                                        />
                                        <TextField
                                            label="Stack Order"
                                            type="number"
                                            value={this.state.model.zIndexMobile}
                                            onChange={(newValue) => this.handleChange('zIndexMobile', newValue)}
                                            clearButton
                                            onClearButtonClick={() => this.handleChange('zIndexMobile', null)}
                                            helpText="Use this to push Sticky Add To Cart Bar either in front or behind other elements. An element with greater stack order will be in front of an element with a lower stack order."
                                        />
                                    </FormLayout>
                                </Card.Section>
                            </Card>
                        </Layout.AnnotatedSection>
                        {
                            this.props.isOnboardingStep == false &&

                            <Layout.AnnotatedSection
                            title="Countdown Timer [Beta]"
                            description="Countdown Timer is a brand new feature in beta! Please chat with our support (bottom right) to report any issues so that we can make this feature even better."
                        >
                            <Card sectioned>
                                <FormLayout>

                                    <Checkbox
                                        label="Enabled Countdown"
                                        checked={this.state.model.enable_CountDownTimer}
                                        onChange={(newValue) => this.handleChange('enable_CountDownTimer', newValue)}
                                    />
                                            {this.state.model.enable_CountDownTimer && (
                                                <div>
                                                    <p style={{ marginBottom: "8px" }}>Countdown Type</p>

                                                    <LegacyStack vertical spacing="extraTight">
                                                        <RadioButton
                                                            label="Restart countdown for each visitor (forever)"
                                                            checked={this.state.model.countDownTimerType === 'repeat'}
                                                            onChange={() => this.handleChange('countDownTimerType', 'repeat')}
                                                        />
                                                        <RadioButton
                                                            label="Fixed end date (turns off after timer expires)"
                                                            checked={this.state.model.countDownTimerType === 'fixed'}
                                                            onChange={() => this.handleChange('countDownTimerType', 'fixed')}
                                                        />
                                                    </LegacyStack>

                                                    {this.state.model.countDownTimerType === 'fixed' && (
                                                        <div style={{ paddingTop: "10px"}}>
                                                            <TextField
                                                                type="datetime-local"
                                                                label="End Date"
helpText={
        <span>
          Timer will automatically stop at this exact date and time.<br/> Use UTC for best accuracy <a href="https://dateful.com/convert/utc" target="_blank" rel="noopener noreferrer">Convert time here</a>
        </span>
      }                                                                value={this.state.model.countDownTimerEndDate}
                                                                onChange={(v) => this.handleChange('countDownTimerEndDate', v)}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                    {this.state.model.enable_CountDownTimer && <span>

                                    {this.state.model.countDownTimerType === 'repeat' && 
                                                <p style={{ fontWeight: "normal" }}>Countdown Duration</p>
                                    }
                                    {this.state.model.countDownTimerType === 'repeat' && (
                                        <div style={{marginBottom:'10px'}}>
                                        <LegacyStack distribution="fillEvenly" wrap={false}>
                                            <div style={{ width: "140px" }}>
                                                <TextField
                                                    suffix="Days"
                                                    value={this.state.model.countDownTimerDays}
                                                    onChange={(newValue) => this.handleChange("countDownTimerDays", newValue)}
                                                    label="Days"

                                                />
                                            </div>
                                            <div style={{ width: "140px" }}>
                                                <TextField
                                                    suffix="Hours"
                                                    value={this.state.model.countDownTimerHours}
                                                    onChange={(newValue) => this.handleChange("countDownTimerHours", newValue)}
                                                    label="Hours"
                                                />
                                            </div>
                                            <div style={{ width: "140px" }}>
                                                <TextField
                                                    suffix="Minutes"
                                                    value={this.state.model.countDownTimerMinutes}
                                                    onChange={(newValue) => this.handleChange("countDownTimerMinutes", newValue)}
                                                    label="Minutes"
                                                />
                                            </div>
                                            <div style={{ width: "110px" }}>

                                                <TextField
                                                    suffix="Seconds"
                                                    value={this.state.model.countDownTimerSeconds}
                                                    onChange={(newValue) => this.handleChange("countDownTimerSeconds", newValue)}
                                                    label="Seconds"
                                                />
                                            </div>
                                        </LegacyStack>
                                        </div>
                                        )}
                                        <div style={{ paddingBottom: "10px" }}>
                                            <TextField
                                                value={this.state.model.countDownTimerText}
                                                onChange={(newValue) => this.handleChange("countDownTimerText", newValue)}
                                                label="Countdown Text"
                                            />
                                        </div>
                                        <p style={{ paddingTop: "10px", paddingBottom: "10px", fontWeight: "normal" }}>Time Abbreviations</p>
                                        <LegacyStack>
                                            <div style={{ width:"280px" }}>
                                                <TextField
                                                    value={this.state.model.countDownTimerDayAbbr}
                                                    onChange={(newValue) => this.handleChange("countDownTimerDayAbbr", newValue)}
                                                    label="Days"
                                                />
                                            </div>
                                            <div style={{ width: "280px" }}>
                                                <TextField
                                                    value={this.state.model.countDownTimerHourAbbr}
                                                    onChange={(newValue) => this.handleChange("countDownTimerHourAbbr", newValue)}
                                                    label="Hours"
                                                />
                                            </div>
                                            <div style={{ width: "280px" }}>
                                                <TextField
                                                    value={this.state.model.countDownTimerMinAbbr}
                                                    onChange={(newValue) => this.handleChange("countDownTimerMinAbbr", newValue)}
                                                    label="Minutes"
                                                />
                                            </div>
                                            <div style={{ width: "280px" }}>
                                                <TextField
                                                    value={this.state.model.countDownTimerSecAbbr}
                                                    onChange={(newValue) => this.handleChange("countDownTimerSecAbbr", newValue)}
                                                    label="Seconds"
                                                />
                                            </div>
                                        </LegacyStack>
                                        <LegacyStack distribution="fill">
                                    <div style={{ padding:"10px" }}>
                                                <ColorPickerCustom
                                                    label="Backgroud Color"
                                                    fieldName="countDownTimerBgColor"
                                                    value={this.state.model.countDownTimerBgColor}
                                                    handleChange={this.handleChange}
                                                />
                                            </div>
                                            <div style={{ padding: "10px" }}>
                                                <ColorPickerCustom
                                                    label="Text Color"
                                                    fieldName="countDownTimertxtColor"
                                                    value={this.state.model.countDownTimertxtColor}
                                                    handleChange={this.handleChange}
                                                />
                                            </div>
                                            <div style={{ paddingBottom: "30px" }}>
                                                <ColorPickerCustom
                                                    label="Timer Duration Color"
                                                    fieldName="countDownTimerDurationColor"
                                                    value={this.state.model.countDownTimerDurationColor}
                                                    handleChange={this.handleChange}
                                                />
                                            </div>
                                            <div></div>
                                            <div></div>
                                        </LegacyStack>
                                        <div style={{ paddingBottom: "10px" }}>

                                            <RangeSlider
                                                output
                                                label="Countdown Text Size"
                                                min={12}
                                                step={2}
                                                max={36}
                                                onChange={(newValue) => this.handleChange('countDownTimerTxtFontSize', JSON.stringify(newValue))}
                                                value={this.state.model.countDownTimerTxtFontSize}
                                            />

                                        </div>
                                        <div style={{ paddingTop: "10px" }}>

                                            <RangeSlider
                                                output
                                                label="Countdown Duration Size"
                                                min={12}
                                                step={2}
                                                max={36}
                                                onChange={(newValue) => this.handleChange('countDownTimerDurationFontSize', JSON.stringify(newValue))}
                                                value={this.state.model.countDownTimerDurationFontSize}
                                            />

                                        </div>


                                    </span>}
                                </FormLayout>

                            </Card>
                        </Layout.AnnotatedSection>

                        }
                        {
                            this.props.isOnboardingStep == false &&

                            <Layout.Section>
                                {window.innerWidth < 768 ?
                                    <LegacyStack alignment="center" distribution="center">
                                        <PageActions primaryAction={{ content: 'Save', onAction: () => { this.saveChanges() } }} />
                                    </LegacyStack>
                                    :
                                    <PageActions primaryAction={{ content: 'Save', onAction: () => { this.saveChanges() } }} />
                                }

                            </Layout.Section>
                        }
                    </Layout>
                </Page >
        );
    }

    async populateData() {
        const response = await fetchApi('api/home/stickyAddToCartBar');
        const data = await response.json();

        if (data.redirectUrl) {
            this.props.navigate(data.redirectUrl);
        }
        else {
            this.props.setIsLoading(false);
            if (data.countDownTimerEndDate) {
                const d = new Date(data.countDownTimerEndDate);

                const year = d.getFullYear();
                const month = String(d.getMonth() + 1).padStart(2, "0");
                const day = String(d.getDate()).padStart(2, "0");

                const hours = String(d.getHours()).padStart(2, "0");
                const minutes = String(d.getMinutes()).padStart(2, "0");

                const dt = `${year}-${month}-${day}T${hours}:${minutes}`;

                data.countDownTimerEndDate = dt;
            }
            this.setState({ initState: data, model: data, loading: false });

            var topNavTimer = setInterval(function(){
                if(window.$('#preview').length > 0){
                    window.$('#preview').sticky({ topSpacing: 50, zIndex: 100 });

                }
            },500);

            window.$('.satcb_title_a').click(function (e) {
                e.preventDefault();
            });
            window.$('.satcb_reviews_count').click(function (e) {
                e.preventDefault();
            });

            btnAnimation = data.buttonAnimation;
            setInterval(function () {
                if (window.$('.satcb_btn:hover').length === 0 && window.$('.satcb_btn:visible').length > 0 && btnAnimation !== 'None') {
                    window.$('.satcb_btn').satcb_animateCss(btnAnimation);
                }
            }, 5000);


            this.setCountDownTimer()


        }
    }

    async saveChanges() {
        this.props.setIsLoading(true);
        const modelToSave = { ...this.state.model };

        if (modelToSave.countDownTimerEndDate) {
            modelToSave.countDownTimerEndDate = new Date(modelToSave.countDownTimerEndDate).toISOString();
        }
        const body = JSON.stringify(modelToSave);
        const response = await fetchApi('api/home/saveStickyAddToCartBar', { method: 'post', headers: { 'Content-Type': 'application/json' }, body: body });
        const data = await response.json();
        this.props.setIsLoading(false);

        if (response.ok === true) {
            if (data.redirectUrl) {
                this.props.navigate(data.redirectUrl);
            }
            else {
                this.setState({ initState: Object.assign({}, this.state.model) });
                this.props.setIsDirty(false);
                this.props.setToastActive(true);
            }
        }
    }


}